// extracted by mini-css-extract-plugin
var _1 = "TaskAddPopup_content__IoMMD";
export { _1 as "content" }
